
<div class="card">
  <div class="card-body">
    <h3>{{ prefix + 'title' | translate }}</h3>
    <p>{{ prefix + 'content' | translate }}</p>
    <button [routerLink]="['/']" class="btn btn-primary">{{ prefix + 'home' | translate }}</button>
  </div>
</div>
